import { APP_SCOPE, QUERY_TYPE } from '@nx/constants';

export const nxMetadata = {
  appScope: APP_SCOPE.framework,
  queryType: QUERY_TYPE.System,
};
